// extracted by mini-css-extract-plugin
export default {"card":"style_card__sc5KA","removing":"style_removing__by2Oy","liking":"style_liking__iDLg7","text":"style_text__RfJfn","button":"style_button__VZ69R"};